export const text = {
  login: 'Login',
  pageTitle: 'Login',
  adminLoginTitle:'Super Administrator',
  heading:'Access the Good Guys panel using your email and password.',
  adminEmailLabel:'Super Administrator E-mail',
  
};
